<!--
 * @Descripttion: 卡片公共属性
 * @Author: zenghua.wang
 * @Date: 2021-09-28 16:58:15
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-10-14 15:45:09
-->
<template>
  <div>
    <el-form-item label="外边距(px)">
      <el-input-number v-model="data.option.margin" />
    </el-form-item>

    <el-form-item label="内边距(px)">
      <el-input-number v-model="data.option.padding" />
    </el-form-item>

    <el-form-item label="每行个数">
      <el-select
        v-model="data.option.col"
        clearable
        placeholder="请选择"
      >
        <el-option
          v-for="item in spanList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="阴影">
      <el-radio-group
        v-model="data.option.shadow"
        size="mini"
      >
        <el-radio-button label="always"></el-radio-button>
        <el-radio-button label="hover"></el-radio-button>
        <el-radio-button label="never"></el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="文本对齐">
      <el-select
        v-model="data.option.textAlign"
        clearable
        placeholder="请选择"
      >
        <el-option
          v-for="item in alignList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
import {
  theme,
  predefineColors,
  component
} from '@/dragComponents/model/default.js'

import configBase from '@/dragComponents/config/common/base.vue'

export default {
  name: 'card-common',
  components: {
    configBase
  },
  props: ['data'],
  data() {
    return {
      theme: theme,
      predefineColors: predefineColors,
      component: component,
      alignList: component.alignType,
      spanList: [
        {
          label: '1个',
          value: 1
        },
        {
          label: '2个',
          value: 2
        },
        {
          label: '3个',
          value: 3
        },
        {
          label: '4个',
          value: 4
        }
      ]
    }
  }
}
</script>
